import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { PaymentDetailsRequirementsItem } from 'shared/data/webApp/v2';

import { FormValues } from '../../EditCounterpartyPaymentDetailsPopupContent.types';
import { fields } from './ThirdStep.constants';
import { isFieldRequirement } from './ThirdStep.helpers';
import { RequiredField } from './ThirdStep.types';

export const useRequiredFields = (requirements: PaymentDetailsRequirementsItem[] | undefined) => {
    const form = useFormContext<FormValues>();

    const [paymentMethod, legalEntityType] = form.watch(['paymentMethod', 'legalEntity.legalEntityType']);

    const requiredFields = useMemo(() => {
        const neededRequirements = requirements?.find(
            (item) =>
                item.payNetworkName === paymentMethod && item.legalEntityTypeField.legalEntityType === legalEntityType
        );

        if (!neededRequirements) {
            return [];
        }

        return fields.reduce<RequiredField[]>((acc, field) => {
            const fieldRequirement = neededRequirements[field.requirementsKey];

            if (isFieldRequirement(fieldRequirement)) {
                acc.push({
                    ...field,
                    description: fieldRequirement.description,
                    validationRegExp: fieldRequirement.requirement ? new RegExp(fieldRequirement.requirement) : null,
                });
            }

            return acc;
        }, []);
    }, [requirements, paymentMethod, legalEntityType]);

    return requiredFields;
};
